import React from "react";
import "./ticketDetail.style";
import { Grid } from '@mui/material';
import { NOT_APPLICABLE } from '../../../constants/originalState';

export interface IPCReturnProps {
  infoTicket: any,
  configTracking: any,
  locale: any,
};

export const enum RETURN_REASON{
  SECOND_OR_BREAK_PC = 'second_OR_break_PC',
  LEAVING_COMPANY = 'leaving_company',
}

const PCReturn = (props:IPCReturnProps) => {
  const { infoTicket, configTracking, locale } = props;
  const variableInfo = infoTicket.variables;
  const isBoxRequired = variableInfo?.json_storage?.shipping_box_required === 'yes';
  const isIndiaUser = variableInfo?.json_storage?.user_country.toLowerCase() === 'ind';
  const returnReason = variableInfo?.json_storage?.return_reason;
  const returnForLeavingCompany = returnReason === RETURN_REASON.LEAVING_COMPANY;
  

  return (
    <Grid container>
      <Grid item xs={12}>
        <p className="ttl-col-desc">{locale?.moreDetails}</p>
        <p className="value-info" id="lbl-pcreturn-moredetails">{isIndiaUser ? locale?.deviceCollection : !!variableInfo?.json_storage?.shipping_box_required ? (isBoxRequired ? locale?.boxRequiredTrue : locale?.boxRequiredFalse) : locale?.na}</p>
      </Grid>
      {!!returnReason && <Grid item xs={returnForLeavingCompany ? 6 : 12}>
        <p className="ttl-col-desc">{locale?.return_reason}</p>
        <p className="value-info" id="lbl-pcreturn-return_reason">{locale?.[returnReason]}</p>
      </Grid>}
      {returnForLeavingCompany && <Grid item xs={6}>
        <p className="ttl-col-desc">{locale?.last_working_date}</p>
        <p className="value-info" id="lbl-pcreturn-last_working_date">{variableInfo?.json_storage?.last_working_date}</p>
      </Grid>}
      <Grid item xs={12}>
        <p className="ttl-col-desc">{locale?.returnedDevice}</p>
        <p className="value-info" id="lbl-pcreturn-serial_number">
        <strong>{locale?.serialNumber}:</strong> {!!variableInfo?.asset?.serial_number ? variableInfo?.asset?.serial_number : (!!variableInfo?.json_storage?.device_serial_number ? variableInfo?.json_storage?.device_serial_number : NOT_APPLICABLE)}
        </p>
        <p className="value-info" id="lbl-pcreturn-model">
        <strong>{locale?.modelName}:</strong> {!!variableInfo?.asset?.model ? variableInfo?.asset?.model : (!!variableInfo?.json_storage?.device_model_name ? variableInfo?.json_storage?.device_model_name : NOT_APPLICABLE)}
        </p>
      </Grid>
      <Grid item xs={6} className="pr-20">
        <p className="ttl-col-desc">{locale?.collectionAddress}</p>
        <p className="value-info value-replacement" id="lbl-pcreturn-delivery_address">
          {variableInfo?.delivery_address ? variableInfo?.delivery_address : NOT_APPLICABLE}
        </p>
      </Grid>
      {isBoxRequired && (
        <Grid item xs={6}>
          <p className="ttl-col-desc">{locale?.trackingInfo}</p>
          <p className="value-info" id="lbl-pcreturn-trackinginfo">
            {configTracking(variableInfo?.delivery_ref)}
          </p>
        </Grid>
      )}
    </Grid>
  );
};

export default PCReturn;
